<app-select-solution></app-select-solution>
<section *ngIf="solutionIsSelected">
    <app-reply-step *ngFor="let solutionStep of solutionSteps; let index = index" [Index]="index"></app-reply-step>
</section>

